import { forwardRef, type InputHTMLAttributes } from "react";
import styles from "./checkbox.module.scss";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, disabled, className, ...props }, ref) => {
    const wrapperCls = [
      styles.wrapper,
      disabled ? styles.disabled : "",
      className ?? "",
    ].filter(Boolean).join(" ");

    return (
      <label className={wrapperCls}>
        <input ref={ref} type="checkbox" className={styles.checkbox} disabled={disabled} {...props} />
        {label && <span className={styles.label}>{label}</span>}
      </label>
    );
  },
);

Checkbox.displayName = "Checkbox";
